export default __webpack_public_path__ + "static/close-71570b1769bad000db3bf836e06c6a5e.svg";